import invariant from 'tiny-invariant';
export const assetCounted = (payload) => ({ type: 'assetCounted', payload });
export const allCheckedChanged = (payload) => ({ type: 'allCheckedChanged', payload });
export const searchValueChanged = (payload) => ({ type: 'searchValueChanged', payload });
export const flatItemsChanged = (payload) => ({ type: 'flatItemsChanged', payload });
export const groupedItemsChanged = (payload) => ({ type: 'groupedItemsChanged', payload });
export const typeFilterChanged = (payload) => ({ type: 'typeFilterChanged', payload });
export const visibleTypeCountersChanged = (payload) => ({
    type: 'visibleTypeCountersChanged',
    payload,
});
export const emptyGroupsChanged = (payload) => ({ type: 'emptyGroupsChanged', payload });
export const treeReducer = (state, action) => {
    switch (action.type) {
        case 'assetCounted':
            return Object.assign(Object.assign({}, state), { assetCounts: action.payload });
        case 'allCheckedChanged':
            return Object.assign(Object.assign({}, state), { allChecked: action.payload });
        case 'searchValueChanged':
            return Object.assign(Object.assign({}, state), { searchValue: action.payload, allChecked: false });
        case 'flatItemsChanged':
            return Object.assign(Object.assign({}, state), { flatItems: action.payload });
        case 'groupedItemsChanged':
            return Object.assign(Object.assign({}, state), { groupedItems: action.payload });
        case 'typeFilterChanged':
            return Object.assign(Object.assign({}, state), { typeFilter: action.payload });
        case 'visibleTypeCountersChanged':
            return Object.assign(Object.assign({}, state), { visibleTypeCounters: action.payload });
        case 'emptyGroupsChanged':
            return Object.assign(Object.assign({}, state), { emptyGroups: action.payload });
        default:
            invariant(false, 'Unknown action type in tree reducer');
    }
};
